import { BiMatricScores } from "../../../pages";
import routesMap from "../../../routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: `${routesMap.BI_METRIC.path}/:id`,
      name: "BiMatricScores",
      key: `${routesMap.BI_METRIC.path}/:id`,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <BiMatricScores />,
    },
  ];
}
